var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 162,
    viewBox: "0 0 178 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5965 161.5C36.7125 161.5 38.0518 161.265 38.9446 160.794L175.991 77.0419C177.107 76.3361 177.777 75.3951 177.777 74.2188C177.777 73.0425 177.107 71.8661 175.545 70.9251L146.975 53.5159C144.743 52.1043 141.618 52.1043 139.609 53.2806L2.56248 136.798C1.44647 137.504 0.776855 138.445 0.776855 139.621C0.776855 140.797 1.44646 141.974 3.00888 142.915L31.5789 160.324C32.9181 161.03 34.2573 161.5 35.5965 161.5ZM37.6054 158.207C36.4893 158.912 34.2573 158.677 32.9181 157.971L4.34811 140.562C3.6785 140.092 3.45531 139.856 3.45531 139.856C3.45531 139.856 3.45529 139.621 3.9017 139.621L141.172 55.8685C142.288 55.1627 144.52 55.398 145.859 56.1037L174.429 73.513C175.098 73.9835 175.322 74.2188 175.322 74.2188C175.322 74.2188 175.322 74.454 174.875 74.454L106.24 116.33L37.6054 158.207Z",
    fill: "#12B7A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.414 5.52486C115.843 7.64221 112.495 10.7006 109.37 14.4648C105.129 0.113859 92.4063 -4.12081 77.0053 5.05435C64.506 12.8179 53.569 27.8746 47.7657 43.6371C45.7569 43.6371 43.7481 44.3428 41.5161 45.7544C33.2576 50.6949 26.5615 62.9284 26.5615 72.8094C26.5615 73.0446 26.5615 73.2799 26.5615 73.5152C24.3294 73.7504 21.651 74.4562 18.9726 76.103C8.48203 82.4551 0.000305176 97.9823 0.000305176 110.686C0.000305176 123.39 8.48203 128.566 18.9726 122.214L119.414 61.0463C132.136 53.2827 142.404 34.6972 142.404 19.17C142.404 3.64277 131.913 -2.23874 119.414 5.52486Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.414 5.52244C117.405 6.69875 115.396 8.34557 113.387 10.2277L102.227 3.40509C95.9776 -1.06486 87.0495 -1.06485 77.2285 5.05193C64.7292 12.8155 53.7922 27.8722 47.9889 43.6347C45.9801 43.6347 43.9713 44.3404 41.7393 45.752C33.4808 50.6925 26.7847 62.926 26.7847 72.807C26.7847 73.0422 26.7847 73.2775 26.7847 73.5127C24.5526 73.748 21.8742 74.4538 19.1958 76.1006C8.70523 82.4527 0.223511 97.9799 0.223511 110.684C0.223511 117.036 2.23233 121.506 5.80359 123.623L33.0343 140.562L39.0608 109.978L119.414 61.0439C132.136 53.2803 142.404 34.6947 142.404 19.1675C142.404 3.64035 131.913 -2.24116 119.414 5.52244Z",
    fill: "url(#paint1_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.608 20.8153L135.708 3.64125C131.467 1.05338 125.663 1.28864 119.414 5.28806C117.405 6.46436 115.396 8.11119 113.387 9.99327L102.227 3.17072C95.9774 -1.29923 87.0493 -1.29922 77.2283 4.81755C64.729 12.5811 53.792 27.6378 47.9887 43.4002C45.9799 43.4002 43.9711 44.106 41.7391 45.5176C33.4805 50.4581 26.7845 62.6916 26.7845 72.5725C26.7845 72.8078 26.7845 73.043 26.7845 73.2783C24.5524 73.5135 21.874 74.2193 19.1956 75.8662C8.705 82.2182 0.223297 97.7454 0.223297 110.449C0.223297 116.801 2.23212 121.271 5.80338 123.389L33.0341 140.563L39.0606 109.979L119.414 61.0448C129.681 54.6927 138.386 41.2829 141.288 28.1083L163.608 20.8153Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.868 22.227C143.297 24.3443 139.948 27.4027 136.824 31.1669C132.583 16.816 119.86 12.5813 104.459 21.7565C91.9598 29.5201 81.0229 44.5767 75.2196 60.3391C73.2108 60.3391 71.2019 61.0449 68.9699 62.4565C60.7114 67.3969 54.0153 79.6305 54.0153 89.5114C54.0153 89.7467 54.0153 89.9819 54.0153 90.2172C51.7833 90.4524 49.1048 91.1582 46.4264 92.805C35.9359 99.157 27.4541 114.684 27.4541 127.388C27.4541 140.092 35.9359 145.268 46.4264 138.916L146.868 77.7484C159.59 69.9848 169.858 51.3992 169.858 35.8721C169.858 20.3449 159.59 14.6987 146.868 22.227Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.123921,
    y1: 92.9492,
    x2: 142.276,
    y2: 92.9492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036C5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#258D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7E9E3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3424 47.8936) scale(67.9271 71.5966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#258D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12B7A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -0.123554,
    y1: 70.3834,
    x2: 163.558,
    y2: 70.3834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7E9E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 27.4789,
    y1: 109.835,
    x2: 169.879,
    y2: 109.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.cdec6ef6eb16138620ea2d6698973044.svg";
export { ForwardRef as ReactComponent };